import React, { Fragment } from 'react';
import type { Nullable } from 'corgi-types';
import type { ReclamationReasonValue } from 'graphql-ts-types';

import { useLocalization } from 'common/providers/LocaleProvider';
import AlertForNoContentStep from '../AlertForNoContentStep';
import EditReasonButton from './EditReasonButton';
import ReasonSection from './ReasonSection';

export interface ReasonProps {
  reason: Nullable<ReclamationReasonValue>;
  isDisabled: boolean;
  onEdit?: () => void;
}

const Reason = ({ reason, isDisabled, onEdit }: ReasonProps) => {
  const { t } = useLocalization();

  return (
    <Fragment>
      {!!onEdit ? (
        <EditReasonButton reason={reason} isDisabled={isDisabled} onClick={onEdit} />
      ) : (
        <ReasonSection reason={reason} />
      )}
      {!reason && <AlertForNoContentStep textContent={t('h24_please_insert_reason_for_request')} />}
    </Fragment>
  );
};

export default Reason;
